'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities for working with JSON Web Tokens (JWT)
 * @namespace Jwt
 * @example
 * import { Jwt } from 'storis-jwt-auth';
 */
var Jwt = function Jwt() {
	(0, _classCallCheck3.default)(this, Jwt);
};

Jwt.getIdentity = function (idToken) {
	var decoded = (0, _jwtDecode2.default)(idToken);
	var _decoded$email = decoded.email,
	    email = _decoded$email === undefined ? null : _decoded$email,
	    _decoded$name = decoded.name,
	    name = _decoded$name === undefined ? null : _decoded$name,
	    _decoded$picture = decoded.picture,
	    picture = _decoded$picture === undefined ? null : _decoded$picture;

	return { email: email, name: name, picture: picture };
};

Jwt.getTokenExpiry = function (token) {
	var decoded = (0, _jwtDecode2.default)(token);
	var _decoded$exp = decoded.exp,
	    exp = _decoded$exp === undefined ? null : _decoded$exp;

	if (!exp && exp !== 0) {
		return null;
	}
	// expiration is expressed in seconds since epoch
	var epoch = new Date(0);
	epoch.setUTCSeconds(exp);
	return epoch.getTime();
};

Jwt.isTokenExpired = function (token) {
	var expiry = Jwt.getTokenExpiry(token);
	if (expiry === null) {
		return false;
	}
	// expiration is expressed in seconds since epoch
	return expiry < new Date().getTime();
};

Jwt.willTokenExpireBefore = function (token, seconds) {
	var expiry = Jwt.getTokenExpiry(token);
	if (expiry === null) {
		return false;
	}
	var checkedTime = new Date();
	checkedTime.setSeconds(checkedTime.getSeconds() + seconds);
	return expiry < checkedTime.getTime();
};

Jwt.isTokenWellFormed = function (token) {
	try {
		var decoded = (0, _jwtDecode2.default)(token);
		return decoded !== null && (typeof decoded === 'undefined' ? 'undefined' : (0, _typeof3.default)(decoded)) === 'object';
	} catch (e) {
		return false;
	}
};

Jwt.isTokenAcceptable = function (token) {
	return !!token && Jwt.isTokenWellFormed(token) && !Jwt.isTokenExpired(token);
};

exports.default = Jwt;